import { Component, Input } from '@angular/core';

@Component({
  selector: 'CDMS-Portal-U2-main-sidenav',
  templateUrl: './main-sidenav.component.html',
  styleUrls: ['./main-sidenav.component.scss']
})
export class MainSidenavComponent {

  @Input() parentScreens: any = [];

  constructor() {}
}
